import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

// Import Lucide icons
import {
  Search,
  Edit2,
  Trash2,
  Copy,
  Check,
  X,
  Calendar,
  CreditCard,
  User,
  Mail,
  AlertCircle,
  Filter,
  ChevronDown,
  Loader as LucideLoader,
} from "lucide-react";
import "./PaidUserSupport.css";

import Logo from "../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import copy from "copy-to-clipboard";
import { Modal } from "react-bootstrap";

function SupportPaidUsers({ adminType }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfUser, setnoOfUser] = useState(0);
  const [loader, setLoader] = useState(false);
  const [searchMail, setSearchMail] = useState("");
  const [resetPage, setResetPage] = useState(false);
  const [reason, setReason] = useState("");

  const [selectedSubscription, setSelectedSubscription] = useState({});
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    setSelectedSubscription(data);
    setShow(true);
  };

  const deleteSubscription = async (id) => {
    try {
      let payload = {
        id: id,
      };
      setLoader(true);
      const userData = await api.SuperAdminDeleteSubs(payload);
      if (userData?.success) {
        alert("Subscription deleted");
        handleSearch();
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
      setLoader(false);
    }
  };

  const cancelSubcription = async () => {
    try {
      if (!reason) {
        alert("Please select reason");
        return;
      }
      setLoader(true);

      const payload = {
        id: selectedSubscription?._id,
        subscriptionId: selectedSubscription?.subscriptionId || "",
        reason: reason || "",
      };

      const resp = await api.SuperAdminCancelSubs(payload);
      setLoader(false);
      handleClose();
      if (resp?.res?.status == "canceled") {
        handleSearch();
        alert("Now user subscription has canceled.");
      } else {
        alert("There is an issue for cancel, try later.");
      }
    } catch (error) {
      setLoader(false);
      console.log(error.message);
      handleClose();
      var err = error?.message || "";
      if (err.includes("No such subscription")) {
        alert("No such subscription");
      } else {
        alert(err);
      }
    }
  };

  const handleSearch = async () => {
    if (searchMail) {
      let payload = {
        email: searchMail,
      };
      const res = await api.searchPaidUsers(payload);
      console.log(res);

      if (res?.success) {
        if (res?.user?.length > 0) {
          setData(res?.user);
        } else {
          alert("User not found");
        }
      } else {
        alert("User not found");
      }
    } else {
      alert("Please insert email for search");
    }
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="support-paid-container-fluid support-paid-page">
        {/* Content Row */}
        <div className="">
          {/* Area Chart */}
          <div className="">
            <div className="support-paid-header">
              <div className="support-paid-header-content mb-0">
                <div className="support-paid-title-section">
                  <div className="support-paid-header-icon-bg">
                    <CreditCard size={24} className="support-paid-title-icon" />
                  </div>
                  <h1 className="support-paid-title">Paid Users</h1>
                  <div className="support-paid-count-badge">
                    <span className="support-paid-count">{noOfUser}</span>
                  </div>
                </div>

                <div className="support-paid-search-container">
                  <div className="support-paid-search-wrapper">
                    <div className="support-paid-search-input-group">
                      <Search size={18} className="support-paid-search-icon" />
                      <input
                        type="text"
                        className="support-paid-search-input"
                        placeholder="Search by email..."
                        value={searchMail}
                        onChange={(e) => setSearchMail(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                      />
                      <button
                        className="support-paid-search-button"
                        onClick={handleSearch}
                      >
                        <Search size={18} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="support-paid-stats-container">
                <div className="support-paid-stat-card">
                  <div className="support-paid-stat-icon">
                    <User size={20} />
                  </div>
                  <div className="support-paid-stat-content">
                    <span className="support-paid-stat-label">Total Users</span>
                    <span className="support-paid-stat-value">{noOfUser}</span>
                  </div>
                </div>
                <div className="support-paid-stat-card">
                  <div className="support-paid-stat-icon">
                    <CreditCard size={20} />
                  </div>
                  <div className="support-paid-stat-content">
                    <span className="support-paid-stat-label">
                      Active Subscriptions
                    </span>
                    <span className="support-paid-stat-value">
                      {data.filter((d) => d.subscriptionId !== "manual").length}
                    </span>
                  </div>
                </div>
                <div className="support-paid-stat-card">
                  <div className="support-paid-stat-icon">
                    <Calendar size={20} />
                  </div>
                  <div className="support-paid-stat-content">
                    <span className="support-paid-stat-label">
                      Manual Entries
                    </span>
                    <span className="support-paid-stat-value">
                      {data.filter((d) => d.subscriptionId === "manual").length}
                    </span>
                  </div>
                </div>
              </div> */}
            </div>

            {/* Table Container */}
            <div className="support-paid-table-container">
              <Table
                data={data}
                setPage={setPage}
                page={page}
                noOfUser={noOfUser}
                limit={limit}
                deleteSubscription={deleteSubscription}
                adminType={adminType}
                handleShow={handleShow}
              />
            </div>
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}
      <Modal show={show} onHide={handleClose} centered className="videoM">
        <Modal.Body>
          <div className="support-paid-modal-content">
            <div className="support-paid-modal-header">
              <h3 className="support-paid-modal-title">Cancel Subscription</h3>
              <button
                className="support-paid-modal-close"
                onClick={handleClose}
              >
                <X size={20} />
              </button>
            </div>

            <div className="support-paid-modal-body">
              <div className="support-paid-modal-alert">
                <AlertCircle
                  size={24}
                  className="support-paid-modal-alert-icon"
                />
                <p>Why are you canceling this user subscription?</p>
              </div>

              <div className="support-paid-form-group">
                <label className="support-paid-form-label">Select Reason</label>
                <div className="support-paid-select-wrapper">
                  <select
                    name="reason"
                    className="support-paid-select"
                    onChange={(e) => setReason(e.target.value)}
                    value={reason}
                  >
                    <option value="">Select a reason...</option>
                    <option value="admin">By Admin</option>
                    <option value="user_request">User Request</option>
                    <option value="payment_issue">Payment Issue</option>
                    <option value="other">Other</option>
                  </select>
                  <ChevronDown
                    size={16}
                    className="support-paid-select-arrow"
                  />
                </div>
              </div>

              <div className="support-paid-modal-info">
                <Calendar size={18} className="support-paid-modal-info-icon" />
                <div>
                  <p className="support-paid-modal-info-label">
                    Subscription will end on:
                  </p>
                  <p className="support-paid-modal-info-value">
                    {formatDate(selectedSubscription?.nextPayment)}
                  </p>
                </div>
              </div>

              <div className="support-paid-modal-actions">
                <button
                  className="support-paid-modal-button support-paid-modal-button-secondary"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  className="support-paid-modal-button support-paid-modal-button-primary"
                  onClick={cancelSubcription}
                  disabled={!reason || loader}
                >
                  {loader ? (
                    <>
                      <LucideLoader
                        size={18}
                        className="support-paid-spinner"
                      />
                      Processing...
                    </>
                  ) : (
                    "Confirm Cancellation"
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

const Table = ({
  data,
  page,
  setPage,
  noOfUser,
  limit,
  deleteSubscription,
  adminType,
  handleShow,
}) => {
  const [copyText, setCopyText] = useState("Copy to clipboard");

  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    if (!date) return "-";
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const handleCopy = (text) => {
    copy(text);
    setCopyText("Copied");
    setTimeout(() => {
      setCopyText("Copy to clipboard");
    }, 3000);
  };

  return (
    <div className="support-paid-card">
      <div className="support-paid-card-header">
        <div className="support-paid-card-title">
          <h2>Subscription Management</h2>
          <span className="support-paid-card-subtitle">
            Manage user subscriptions and billing information
          </span>
        </div>
      </div>

      <div className="support-paid-table-wrapper">
        {data.length === 0 ? (
          <div className="support-paid-empty-state">
            <div className="support-paid-empty-state-icon">
              <User size={48} />
            </div>
            <h3 className="support-paid-empty-state-title">
              No Paid Users Found
            </h3>
            <p className="support-paid-empty-state-description">
              Use the search bar above to find paid users by email address.
            </p>
          </div>
        ) : (
          <table className="support-paid-table">
            <thead className="support-paid-table-header">
              <tr>
                <th className="support-paid-table-th">
                  <div className="support-paid-table-header-cell">
                    <User size={16} />
                    <span>Name</span>
                  </div>
                </th>
                <th className="support-paid-table-th">
                  <div className="support-paid-table-header-cell">
                    <Mail size={16} />
                    <span>Email</span>
                  </div>
                </th>
                <th className="support-paid-table-th">
                  <div className="support-paid-table-header-cell">
                    <CreditCard size={16} />
                    <span>Type</span>
                  </div>
                </th>
                <th className="support-paid-table-th">
                  <div className="support-paid-table-header-cell">
                    <Calendar size={16} />
                    <span>Last Paid</span>
                  </div>
                </th>
                <th className="support-paid-table-th">
                  <div className="support-paid-table-header-cell">
                    <Calendar size={16} />
                    <span>Subscription End</span>
                  </div>
                </th>
                {adminType == "sackAdmin755" && (
                  <th className="support-paid-table-th">
                    <div className="support-paid-table-header-cell">
                      <Filter size={16} />
                      <span>Actions</span>
                    </div>
                  </th>
                )}
              </tr>
            </thead>
            <tbody className="support-paid-table-body">
              {data.map((item, key) => (
                <tr key={key} className="support-paid-table-row">
                  <td className="support-paid-table-td">
                    <div className="support-paid-user-info">
                      <div className="support-paid-user-avatar">
                        {item?.userdata?.name?.charAt(0) ||
                          item?.name?.charAt(0) ||
                          "U"}
                      </div>
                      <div className="support-paid-user-details">
                        <span className="support-paid-user-name">
                          {item?.userdata?.name || item?.name || "N/A"}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td className="support-paid-table-td">
                    <div className="support-paid-email-cell">
                      <span className="support-paid-email">
                        {item?.userdata?.email || item?.email}
                      </span>
                      <button
                        className="support-paid-copy-button"
                        onClick={() =>
                          handleCopy(item?.userdata?.email || item?.email)
                        }
                        title="Copy email"
                      >
                        <Copy size={14} />
                      </button>
                    </div>
                  </td>
                  <td className="support-paid-table-td">
                    <div className="support-paid-type-badge">
                      <span className="support-paid-badge">
                        {item?.amount == "10" ? "Monthly" : "Yearly"}
                      </span>
                    </div>
                  </td>
                  <td className="support-paid-table-td">
                    <div className="support-paid-date-cell">
                      <Calendar size={14} className="support-paid-date-icon" />
                      <span>{formatDate(item?.lastPaid)}</span>
                    </div>
                  </td>
                  <td className="support-paid-table-td">
                    <div className="support-paid-date-cell">
                      <Calendar size={14} className="support-paid-date-icon" />
                      <span>{formatDate(item?.nextPayment)}</span>
                    </div>
                  </td>
                  {adminType == "sackAdmin755" && (
                    <td className="support-paid-table-td">
                      <div className="support-paid-actions">
                        {item?.subscriptionId == "manual" ? (
                          <div className="support-paid-manual-badge">
                            <span className="support-paid-manual-text">
                              Added by Admin
                            </span>
                          </div>
                        ) : (
                          <button
                            className="support-paid-action-button support-paid-action-button-cancel"
                            onClick={() => handleShow(item)}
                          >
                            <X size={16} />
                            Cancel Subscription
                          </button>
                        )}
                        <button
                          className="support-paid-action-button support-paid-action-button-delete"
                          onClick={() => deleteSubscription(item?._id)}
                        >
                          <Trash2 size={16} />
                          Delete
                        </button>
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {data.length > 0 && (
        <div className="support-paid-pagination-container">
          <div className="support-paid-pagination-info">
            Showing {data.length} of {noOfUser} users
          </div>
          <div className="support-paid-pagination">
            <Pagination
              count={Math.ceil(noOfUser / limit)}
              page={page}
              onChange={handleChange}
              shape="rounded"
              color="primary"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SupportPaidUsers;
